import React from "react";
import { useRequest } from "ahooks";
import OrderDTO from "@/dto/order/OrderDTO";
import { deleteAbnormalRecord } from "@/services/api/order";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { message } from "antd";
import { useOrderManagementStore } from "../store/OrderManagementStore";
import { collectEvent } from "@/services/dataTrack";
import DataTrackEvent from "@/services/dataTrack/enum/DataTrackEvent";
import OrderTabNameMap from "../map/OrderTabNameMap";
import { useGlobalStore } from "@/store/hooks";
import ShopTypeNameMap from "@/map/ShopTypeNameMap";

const useDeleteAbnormalCause = (tab: OrderTab) => {
    const orderManagementStore = useOrderManagementStore();
    const globalStore = useGlobalStore();
    const { runAsync, loading: deleting } = useRequest(deleteAbnormalRecord, { manual: true });

    const handleDeleteAbnormalCause = async (orders: OrderDTO[]) => {
        await runAsync(orders);

        const shopId = orders[0].shopId;

        orderManagementStore.fetchOrders(shopId, OrderTab.ABNORMAL);

        message.success("删除异常成功");

        const shop = globalStore.shopMapping.get(shopId);

        collectEvent(DataTrackEvent.DELETE_ABNORMAL_RECORD, {
            count: orders.length,
            context: OrderTabNameMap[tab],
            shop_id: shopId,
            shop_name: shop.name,
            shop_type: ShopTypeNameMap[shop.type],
        });
    };

    return {
        handleDeleteAbnormalCause,

        deleting,
    };
};

export default useDeleteAbnormalCause;
